import { useEffect, useRef, useState } from 'react'
import dayjs from 'dayjs'

import { getCurrentScriptDateParts, ScriptCurrentDateParts } from '@/utils/time'

type Timezone = string | null

const getFormattedDateParts = (
  timezone: Timezone | null,
): ScriptCurrentDateParts =>
  getCurrentScriptDateParts(timezone ?? dayjs.tz.guess())

export const useFormattedCurrentDateParts = (
  timezone: Timezone = null,
): ScriptCurrentDateParts => {
  const [startFormatted, setStartFormatted] = useState<ScriptCurrentDateParts>(
    () => getFormattedDateParts(timezone),
  )
  const intervalRef = useRef<NodeJS.Timeout>()

  useEffect(() => {
    intervalRef.current = setInterval(() => {
      setStartFormatted(getFormattedDateParts(timezone))
    }, 1000)

    return () => {
      if (intervalRef.current) {
        clearInterval(intervalRef.current)
      }
    }
  }, [timezone])

  return startFormatted
}
